import React from "react";
import "./Hero.css";

import herobackGround from "../../assets/heroDouts.svg";
import homeBrand from "../../assets/APCRDA Stamp.png";
import homeBrand2 from "../../assets/Aprera_logo (3).png";

const Hero = () => {
  return (
    <div
      className="hero-section container-fluid"
      style={{ backgroundImage: `url(${herobackGround})` }}
    >
      <div className="row">
        <div className="col-lg-6 d-flex flex-column justify-content-center align-items-start text-left">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
              marginTop : "20px"
            }}
          >
            <img
              src={homeBrand}
              alt="Additional"
              className="image-fluid additional-image"
            />
            <img
              src={homeBrand2}
              alt="Additional"
              className="image-fluid additional-image"
            />
          </div>
          <div className="d-flex align-items-center">
            <p className="hero-title">Build Your </p>
          </div>
          <p className="hero-subTitle">Dream Home</p>

          <div className="d-flex flex-column">
            <p className="hero-description ">
              Prime Investment For Prosperous Life <br />
            </p>
            <p className="hero-description">
              L.P.No: 89/2024/1168/AMRVTHI/DPMS
            </p>
            <p className="hero-description">
              Registration Number: P07090105615
            </p>
            <p className="hero-description">CRDA Aproval</p>
          </div>
        </div>
        <div className="col-lg-6">
          <img
            src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F0b466973034f4801a2baf2fbac3ff38a`}
            alt="Hero"
            className="img-fluid hero-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
